module.exports = __webpack_public_path__ + "img/IEC30385.359db4a6.png";